import React, { useState, useEffect } from "react";
import { Box, VStack, Heading, Text, useColorModeValue, Button, SimpleGrid, HStack,  Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    useBreakpointValue, } from "@chakra-ui/react";
import axios from "axios";
import { Batch, StudentInfo } from "../Common/types";

const StudentAttendance = () => {

  const [currentStudent, SetCurrentStudent] = useState<StudentInfo>();
  const textColor = useColorModeValue("blue.800", "blue.50");
  const bannerColor = useColorModeValue("yellow.100", "yellow.700");  
  const showBanner = useBreakpointValue({ base: false, md: true }); // Hide footer on smaller screens
  

  useEffect(() => {
    const fetchCurrentStudent = async () => {
      try {
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const response = await axios.get(`${apiurl}/students-info`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        SetCurrentStudent(response.data);
      } catch (error) {
        console.error("Error fetching Student Info:", error);
      }
    };
    fetchCurrentStudent();
  }, []);


  return (

    <Box>
      {showBanner && (
    <Box bgColor={bannerColor} p={4} height={"70px"}>
      <HStack>
        <Heading  size={"sm"}>Hello  {currentStudent?.givenName} ! </Heading>
        <Text  fontWeight={"normal"} fontSize={"md"}>Checkout the Attendance space to look at how many classes you were able to take.</Text>      
        </HStack>
    </Box>
              )}
              {!showBanner && (
              <Box p={4} bgColor={bannerColor} height={"50px"}>
                <VStack>
                  <Text  fontWeight={"semibold"} fontSize={"md"}>My Attendance</Text>      
                  </VStack>
              </Box>
              )}
    <Box as="main" mx="auto" maxWidth="1200px" color={textColor} p={10}>

   
      <Heading size="md" textAlign="center" mb={4}>
        We are currently working on this module and you will see the details in few days!!
      </Heading>


    </Box>
    </Box>
  );
};

export default StudentAttendance;
